export const YT_PRIVACY_PRIVATE = 'private';
export const YT_PRIVACY_UNLISTED = 'unlisted';
export const YT_PRIVACY_PUBLIC = 'public';
